/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./StringDesignPanel.vue?vue&type=template&id=2f007a52&scoped=true&"
import script from "./StringDesignPanel.vue?vue&type=script&lang=js&"
export * from "./StringDesignPanel.vue?vue&type=script&lang=js&"
import style0 from "./StringDesignPanel.vue?vue&type=style&index=0&id=2f007a52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f007a52",
  null
  
)

export default component.exports